export default __webpack_public_path__ + "static/van-king-long-d867830f6bed3b3dc11348e50005184a.png";